import { SelectItem } from '@kistill/client/data-access'
import { KistillFormAutocompleteCustomer } from './KistillFormAutocompleteCustomer'
import {
  AutocompleteChangeDetails,
  AutocompleteChangeReason,
  Grid,
  IconButton,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

interface CustomerSelectorProps {
  name: string
  label: string
  selectedContacts: SelectItem[]
  setSelectedContacts: (selectedContacts: SelectItem[]) => void //React.Dispatch<React.SetStateAction<SelectItem[]>>
  setOpenCustomerPopup: (value: boolean) => void
  onCustomerChange: (
    _event: React.SyntheticEvent<Element, Event>,
    value: unknown,
    _reason: AutocompleteChangeReason,
    _details?: AutocompleteChangeDetails<unknown> | undefined,
  ) => void
}

export function KistillCustomerSelector({
  name,
  label,
  selectedContacts,
  setSelectedContacts,
  setOpenCustomerPopup,
  onCustomerChange,
}: CustomerSelectorProps) {
  return (
    <Grid item container alignItems='center'>
      <Grid item xs={11}>
        <KistillFormAutocompleteCustomer
          name={`${name}`}
          label={label}
          multiple={true}
          onChange={onCustomerChange}
          selectedContacts={selectedContacts ?? []}
          setSelectedContacts={setSelectedContacts}
        />
      </Grid>
      <Grid item xs={1} alignSelf='center' pl={1}>
        <IconButton
          onClick={() => setOpenCustomerPopup(true)}
          sx={{
            p: '4px',
            backgroundColor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.common.white,
          }}
        >
          <AddIcon />
        </IconButton>
      </Grid>
    </Grid>
  )
}
